// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__14LYM","header":"MergedInvoice_header__1UKUr"};